<template >
    <div class="container-fluid" v-if="lesson">
      <h1 class="text-center">{{lesson.name}}</h1>
      <p>{{lesson.description}}</p>
       <!-- <div v-if="lesson.files!=null && lesson.files.length>0" class="py-5">
           <h4>Хичээлийн файлууд</h4>
        <ul class="list-group">
          <li class="list-group-item" v-for="(file) in lesson.files" v-bind:key="file.id">
            {{file.title}}

            <a class="btn btn-sm btn-success" v-bind:href="file.fileUrl" target="_blank">татах</a>
          </li>
        </ul>
      </div> -->
   
      
      <div class="card shadow mb-4" v-for="(topic) in topics" v-bind:key="topic.id" >
        <div class="card-header py-3">
          <div class="row">
            <div class="col">
              <h3 class="m-0 font-weight-bold text-primary">{{topic.name}}</h3>
            </div>
            <div class="col col-auto">
              <button class="btn btn-success btn-sm" v-if='topic.attendance!=true' @click="attendTopic(topic)">Ирц өгөх</button>
              <span v-else class="badge badge-primary">ирц өгсөн</span>
            </div>
          </div>
          <p>{{topic.description}}</p>

        </div>
        <div class="card-body" >
          <div class="list-group">
            <div v-for="(item, index) in topic.details" v-bind:key="item.id"  class="video list-group-item list-group-item-action flex-column align-items-start ">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{index+1}}. {{item.name}}</h5>
                <small v-if="item.type!=null && item.type!=undefined">{{item.type}}</small>
              </div>
             
              <p class="mb-1">{{item.description}}</p>

              <!-- video container -->
              <div :ref="'youtube_container_'+item.id" >
                <youtube :fitParent="true" v-if="item.videoUrl!=null && item.videoUrl!=''" :video-id="getYoutubeIframe(item.videoUrl)" :ref="'youtube'+item.id" :player-vars="playerVars" @playing="playing(topic, item)"></youtube>
                <br/>
              
                 <!-- video control buttons -->
                <button class="btn btn-primary" v-if="item.videoUrl!=null && item.videoUrl!=''"  @click="playVideo(item.id)"><i class="fas fa-play"></i> Видео тоглуулах</button>
                <button class="btn btn-danger ml-3" v-if="item.videoUrl!=null && item.videoUrl!=''"  @click="pauseVideo(item.id)"><i class="fas fa-pause"></i> Видео зогсоох</button>
                <button class="btn btn-info ml-3" v-if="item.videoUrl!=null && item.videoUrl!=''" @click="fullScreen(item.id)"><i class="fas fa-expand"></i> FullScreen</button>
                <!-- <button class="btn btn-info ml-3" v-if="item.videoUrl!=null && item.videoUrl!=''" @click="exitfullScreen(item.id)"><i class="fas fa-compose"></i>Exit FullScreen</button> -->
              </div>

              <!-- test stat button -->
              <button class="btn btn-danger" v-if="item.type!=null && item.type!=undefined && (item.type=='exam' || item.type=='test') && item.published==true" @click="goStat(topic, item)">Статистик харах</button>

              <ul>
        
                <li v-if="item.files!=null && item.files.length>0">
                  <div >
                      <div v-for="(file, index) in item.files" v-bind:key="file.id" v-if="validFile(file)">
                        <a v-bind:href="file.fileUrl" target="_blank"><i class="fas fa-download"></i> {{file.fileName}}</a>
                      </div>
                  </div>
                </li>
              </ul>

            </div>
           
          </div>
        </div>
      </div>

    </div>
    
</template>

<script>
const fb = require('../firebaseConfig.js')
import { mapState } from 'vuex'
import Vue from 'vue'
import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube);

export default {
    name: "LessonDetailPublic",
    data() {
        return {
            lesson: null,
            topic:{
              'name':null,
              'description':null
            },
            topics:[],
            types:[],
            selectedType:null,
            playerVars: {
              autoplay: 0,
              modestbranding: 1,
              showinfo:0,
              rel:0,
              fs:0
              // controls:0,
              // allowfullscreen:true,
              // autohide:1
            }
            
        };
    },
    methods: {
      async playVideo(videoId){
        // console.log(this.$refs['youtube'+videoId][0].player.getIframe().then(iframe){});
        if(this.$refs['youtube'+videoId][0].player!=undefined)
          await this.$refs['youtube'+videoId][0].player.playVideo();
      },
      async pauseVideo(videoId){

        if(this.$refs['youtube'+videoId][0].player!=undefined)
          await this.$refs['youtube'+videoId][0].player.pauseVideo();
      },
      fullScreen(videoId){
        if(this.$refs['youtube'+videoId][0].player!=undefined){
          var player=this.$refs['youtube'+videoId][0].player;
          player.playVideo();//won't work on mobile
          // player.getIframe().then(iframe=>{
            // console.log(ifr);
            var iframe=this.$refs['youtube_container_'+videoId][0];
            var requestFullScreen = iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullScreen || iframe.msRequestFullscreen;
            if (requestFullScreen) {
              requestFullScreen.bind(iframe)();
            }
          // });
        }
      },
      exitfullScreen(videoId){
        if(this.$refs['youtube'+videoId][0].player!=undefined){
          var player=this.$refs['youtube'+videoId][0].player;
          player.playVideo();//won't work on mobile
     
            var document=this.$refs['youtube_container_'+videoId][0];
            console.log(document.exitFullscreen);
             if (document.exitFullscreen) {
                  document.exitFullscreen();
              } else if (document.webkitExitFullscreen) {
                  document.webkitExitFullscreen();
              } else if (document.mozCancelFullScreen) {
                  document.mozCancelFullScreen();
              } else if (document.msExitFullscreen) {
                  document.msExitFullscreen();
              }

        }
      },
      _getQA(){
          fb.db.collection("lessons").doc(this.lessonId).update({"viewCount": fb.firestore.FieldValue.increment(1)});

          fb.db.collection("lessons").doc(this.lessonId).onSnapshot(doc=> {
              let lesson=doc.data()
              lesson.id=doc.id
              this.lesson=lesson;

          });
          if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.customer!=null){
            fb.db.collection("lessons").doc(this.lessonId).collection("studentList").doc(this.$store.getters.userProfile.customer.id).onSnapshot(stdDoc=> {
              this.topics=[];
              if(stdDoc.exists && stdDoc.data().enabled==true){
                fb.db.collection("lessons").doc(this.lessonId).collection("topics").orderBy("createdAt","desc").get().then(querySnapshot=> {
                  
                  querySnapshot.forEach(doc=> {
                    let object=doc.data()
                    object.id = doc.id;
                    object.details=[];

                    object.attendance=false;
                    stdDoc.ref.collection("attendance").doc(doc.id).get().then(atdValue=>{
                      if(atdValue.exists && atdValue.data().status==true)
                        object.attendance=true;
                    });

                    doc.ref.collection("details").orderBy("createdAt").onSnapshot(contentSnapshot=> {
                      object.details=[];
                      contentSnapshot.forEach(contentDoc=> {
                        let content=contentDoc.data()
                        content.id = contentDoc.id;
                        content.uploading=false
                        content.uploadPercent=0
                        object.details.push(content);
                      });
                      
                    });
                    this.topics.push(object);
                  });
                  
                });
              }
            });
            
            
          }

      },
      playing(topic, content) {
        // console.log('\o/ we are watching!!!'+content.id);
        fb.db.collection("lessons").doc(this.lessonId).collection("studentList").doc(this.$store.getters.userProfile.customer.id).get().then(std=>{
            if(std.exists){
              if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.role=="student"){
                if(topic!=null && content!=null){
                  var contentRef=fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(topic.id).collection("details").doc(content.id);
                  contentRef.collection('watchedStudents').doc(std.id).get().then(stdWatch=>{
                    if(stdWatch.exists){
                      stdWatch.ref.update({watchedDates: fb.firestore.FieldValue.arrayUnion(new Date())});
                    }
                    else{
                      stdWatch.ref.set({"createdAt":new Date(), watchedDates:[new Date()]});
                      this.countStudentVideo(topic, content, 'viewCount');
                    }
                  });
                }
              }
            }

          });
      },
      countStudentVideo(topic, content, prop){
        console.log("count");
        if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.role=="student"){
          if(topic!=null && content!=null){
            var contentRef=fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(topic.id).collection("details").doc(content.id);
            var updateObj={};
            updateObj[prop]=fb.firestore.FieldValue.increment(1);
            contentRef.update(updateObj);
          }
        }
      },
      attendTopic(topic){
        if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.customer!=null){
            fb.db.collection("lessons").doc(this.lessonId).collection("studentList").doc(this.$store.getters.userProfile.customer.id).collection('attendance').doc(topic.id).get().then(value=>{
              if(value.exists){
                if(value.data().status!=true){
                  value.ref.update({status:true});
                }
              }
              else{
                value.ref.set({status:true});
              }
              topic.attendance=true;
            });
        }
      },
      validFile(file){
        if(file.fileName.endsWith("mp4") 
            || file.fileName.endsWith("MP4") 
            || file.fileName.endsWith("MPEG") 
            || file.fileName.endsWith("mov") || file.fileName.endsWith("MOV")
            || file.fileName.endsWith("webm") || file.fileName.endsWith("WEBM")
          ){
            return false;
        }
        return true;
      },
      getYoutubeId(url) {
          const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          const match = url.match(regExp);

          return (match && match[2].length === 11)
            ? match[2]
            : null;
      },
      getYoutubeIframe(url){
        if(url!=null && url!='' && url.toLowerCase().indexOf("youtube") != -1){
          var id= this.getYoutubeId(url);
          return id ;
        }
        return null;
      },
      goStat(topic, item){
        if(topic!=null && item!=null && item.type!=null && item.type!=undefined && (item.type=='exam' || item.type=='test')){
          this.$router.push({ name: 'TestResult', params: { lessonId: this.lessonId, topicId: topic.id, contentId: item.id} });
        }
      }


    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        lessonId: { 
            required: true,
        }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA();
            
    },
  
};
</script>
<style>
    .video iframe {
        pointer-events: none;
        
    }
 
</style>


